<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
  >
    <path
      d="M47.2716 41.3972C50.4904 38.5285 52.313 34.7047 52.313 30.7367C52.313 26.5196 50.3389 22.5757 46.7541 19.6308C43.2652 16.7656 38.6471 15.1875 33.75 15.1875C28.8529 15.1875 24.2348 16.7656 20.7464 19.631C17.1617 22.5757 15.1875 26.5196 15.1875 30.7367C15.1875 34.9537 17.1617 38.8976 20.7464 41.8425C24.2348 44.7079 28.8529 46.2859 33.75 46.2859C34.4025 46.2859 35.0591 46.2571 35.7101 46.1998L36.8224 47.1639C40.6543 50.4844 45.5546 52.3123 50.625 52.3125H52.3125V48.7206L51.8183 48.2264C49.8686 46.271 48.3236 43.9503 47.2716 41.3972ZM39.0328 44.6133L36.801 42.6789L36.0568 42.7701C35.2914 42.8637 34.5211 42.9107 33.75 42.9107C25.3758 42.9107 18.5625 37.4494 18.5625 30.7367C18.5625 24.0239 25.3758 18.5625 33.75 18.5625C42.1242 18.5625 48.9375 24.0238 48.9375 30.7367C48.9375 34.0811 47.269 37.2034 44.2393 39.5283L43.2674 40.2741L43.7158 41.5434C44.6349 44.1358 45.9857 46.5541 47.7112 48.696C44.4978 48.1596 41.4948 46.7468 39.0328 44.6133Z"
      fill="#404A57"
    />
    <path
      d="M6.34764 33.4838C7.92727 31.4842 9.16752 29.2387 10.0188 26.8368L10.4639 25.5739L9.49282 24.8286C6.63588 22.6363 5.0625 19.694 5.0625 16.5435C5.0625 10.2129 11.497 5.0625 19.4062 5.0625C25.2248 5.0625 30.245 7.85004 32.4925 11.8441C32.9098 11.8239 33.329 11.8125 33.75 11.8125C34.5956 11.8125 35.4336 11.8535 36.2637 11.9356C35.3952 9.68541 33.8868 7.6313 31.813 5.92798C28.4842 3.19349 24.0785 1.6875 19.4062 1.6875C14.734 1.6875 10.3283 3.19349 6.99933 5.92798C3.57391 8.74178 1.6875 12.5118 1.6875 16.5435C1.6875 20.3193 3.41212 23.9574 6.45996 26.6941C5.46533 29.0877 4.01198 31.2636 2.18183 33.0992L1.6875 33.5934V37.125H3.375C6.49551 37.1246 9.57311 36.3979 12.3642 35.0024C12.0582 33.8424 11.8788 32.6526 11.8294 31.4539C10.1353 32.4468 8.27979 33.1339 6.34764 33.4838Z"
      fill="#404A57"
    />
  </svg>
</template>

<script>
export default {
  name: "IconChatBubble",
};
</script>

<style></style>
